module.exports = __webpack_public_path__ + "media/images/emblems/Logoicogne-e3af32b389ceeebea1c49853dbeba89a.png";